// eslint-disable-next-line local-rules/validate-freelancer-imports
import type { PushDocumentType } from '@freelancer/datastore/core';
import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  CustomerWebhook,
  CustomerWebhooksCollection,
} from '../collections/customer-webhooks';

export function addPushTransformers(): void {}

export function addCustomerWebhookComputedFields(
  authUid: number,
  document: PushDocumentType<CustomerWebhooksCollection>,
): CustomerWebhook {
  return {
    ...document,
    id: generateId(),
  };
}
